import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth/auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const Authorization = 'Bearer ' + this.authService.getAuthToken();
    request = request.clone({
      headers: request.headers
        .set('authorization', Authorization ? Authorization : '')
    });
    return next.handle(request).pipe(tap(
    event => {
    },
    err => {
      console.log(err);
    }
  ));

  }
}
